export default "__VITE_ASSET__CVmxZmed__"